/* crst-support-fx.js — page-specific FX for the Support hub.
   Relocated (behavior-for-behavior) from the former monolith sections/crst-support.liquid
   inline <script>, after the HUB was split into independent, draggable crst-support-*
   module sections:
     1) scroll-reveal (fade-up on enter, honors data-delay + reduced-motion) with a
        first-fold backstop (mirrors crst-why-fx.js / crst-home-fx.js) so a module sitting
        just below the fold isn't left blank for the first ~120px of scroll.
     2) FAQ category chips + live search filter. This is CROSS-SECTION: the search box
        lives in crst-support-hero, the FAQ list/tabs/no-results live in crst-support-faq.
        They are wired here through document-level stable hooks ([data-cs-search],
        [data-cs-faq], [data-cs-cattabs], [data-cs-nores]) rather than section.id, because
        the two are now separate sections.

   NOTE: the monolith's POLICY TOC scrollspy is NOT here — it stays in the monolith
   (it targets [data-cpolicy-toc]/[data-cpolicy-main], which the crst-policy snippet renders
   only on the policy pages the monolith still serves). The hub has no in-page anchor nav.

   Document-scoped + run-once (window.__crstSupportFx) so every crst-support-* section can
   include it safely (multiple includes = one execution). Each handler no-ops when its
   markup is absent, so it is harmless on a hub built from any subset of the modules. */
(function(){
  if(window.__crstSupportFx)return;window.__crstSupportFx=1;

  function init(){
    var root=document;

    /* 1) scroll reveal — fade up on enter, honors data-delay + reduced-motion */
    (function(){
      var els=root.querySelectorAll('.reveal'); if(!els.length) return;
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches || !('IntersectionObserver' in window)){
        els.forEach(function(el){ el.classList.add('in'); }); return;
      }
      var io=new IntersectionObserver(function(ents){
        ents.forEach(function(en){
          if(!en.isIntersecting) return;
          var d=en.target.getAttribute('data-delay'); if(d) en.target.style.transitionDelay=d+'ms';
          en.target.classList.add('in'); io.unobserve(en.target);
        });
      },{threshold:0.1,rootMargin:'0px 0px -8% 0px'});
      /* First-fold backstop: anything at or near the fold reveals on load, so a module
         just below the fold isn't left blank until the first scroll. */
      var vh=window.innerHeight||document.documentElement.clientHeight||0;
      els.forEach(function(el){
        var r=vh?el.getBoundingClientRect():null;
        if(r && r.top<vh*1.2 && r.bottom>-40){
          var d=el.getAttribute('data-delay'); if(d) el.style.transitionDelay=d+'ms';
          el.classList.add('in');
        } else {
          io.observe(el);
        }
      });
    })();

    /* 2) FAQ category + search filter (cross-section, hub layout) */
    (function(){
      var faq=root.querySelector('[data-cs-faq]'); if(!faq) return;
      var items=Array.prototype.slice.call(faq.querySelectorAll('details.faq'));
      var tabs=root.querySelector('[data-cs-cattabs]');
      var nores=root.querySelector('[data-cs-nores]');
      var search=root.querySelector('[data-cs-search]');
      var curCat='all', curQ='';
      var apply=function(){
        var any=false;
        items.forEach(function(it){
          var okCat=curCat==='all' || it.getAttribute('data-cat')===curCat;
          var okQ=!curQ || (it.getAttribute('data-text')||'').indexOf(curQ)>-1;
          var show=okCat && okQ;
          it.classList.toggle('hide', !show);
          if(show) any=true;
        });
        if(nores) nores.classList.toggle('show', !any);
      };
      if(tabs){
        tabs.addEventListener('click', function(e){
          var t=e.target.closest('.cat-tab'); if(!t) return;
          tabs.querySelectorAll('.cat-tab').forEach(function(x){ x.classList.remove('on'); });
          t.classList.add('on'); curCat=t.getAttribute('data-cat'); apply();
        });
      }
      if(search){
        search.addEventListener('input', function(){ curQ=this.value.trim().toLowerCase(); apply(); });
      }
    })();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }
})();
